<template>
<div>
  <div v-if="subscProds.length < 1" 
    style="display: flex; justify-content: center; align-items: center; min-height: 100px; margin-top: 10px;" >
    <span class="fw400">
      사용{{ !used ? '가능' : '' }}한 서비스가 없습니다.
    </span>
  </div>
  
  <ul class="coupon_slides" style="height:content-fit" v-show="subscProds.length > 0">
    <template v-for="(prod,index) in subscProds">
      <li class="slide-container" :key="`coupon_prod_con_${index}`" style="border-bottom: 1px solid #E6E6E6; padding-bottom: 10px;">
        <div class="slide pmslide" >

          <div class="titWrap" :class="used ? 'space-between':''" style="margin-top: 15px;">
            <span class="" style="display: flex;">
              <h3 :class="used ? 'opt40' : ''">{{prod.title}}</h3>
              <span v-if="prod.unit_type==NUMBER" class="count" :class="used ? 'opt40' : ''" style="padding-left: 5px;">
                {{ (prod.unit_base === 999) ? '무한제공' : `${prod.unit_base} 회` }}
              </span>
              <span v-if="!used" :class="['tglBtn11', (prod.on) ? 'on': '']" @click="prod.on = !prod.on"></span>
            </span>
            <h3 v-if="used">{{ (prod.used) ? '사용완료' : '기간만료' }}</h3>
          </div>

          <div class="pmCouponImgBox">

            <!-- <div class="expiration pmExpiration" v-if="used">
              <strong class="pmExpireBtn">{{ (prod.used) ? '사용완료' : '기간만료' }}</strong>
            </div> -->

            <div class="infoTable03">
              <ul>
                <li v-if="used" class="opt40">
                  <em>유효기간</em>
                  <span>{{getDateFormat(prod.date_start, 'YY.MM.DD')}} ~ {{getDateFormat(prod.date_stop, 'YY.MM.DD')}}</span>
                </li>

                <template v-if="used && prod.used">
                  <li class="opt40">
                    <em>사용</em>
                    <span v-if="prod.unit_type==NUMBER">{{prod.used.unit}}회</span>
                    <span v-if="prod.unit_type==CURRENCY">{{ String(Const.getPriceAddVatRound(prod.used.unit)) | currency }}원</span>
                  </li>
                  <li class="opt40"><em>사용일자</em><span>{{getDateFormat(prod.used.date, 'YY.MM.DD')}}</span></li>
                  <li class="opt40"><em>사용지점</em><span>{{DEALER_AGENT_CDKS[prod.used.dealer_agent_cdk_slug].title}}</span></li>
                </template>

                <template v-else>
                  <li>
                    <em >{{ (prod.unit_type == CURRENCY) ? '잔액' : '잔여횟수' }}</em>
                    <span v-if="prod.unit_type==NUMBER">{{ (prod.unit_base === 999) ? '무한제공' : `${prod.unit_base - prod.unit} 회` }}</span>
                    <span v-if="prod.unit_type==CURRENCY">{{ String(Const.getPriceAddVatRound(prod.unit_base - prod.unit)) | currency }}원</span>
                  </li>
                </template>
                
                <li v-if="!used">
                  <em>유효기간</em>
                  <span>{{getDateFormat(prod.date_start, 'YY.MM.DD')}}~{{getDateFormat(prod.date_stop, 'YY.MM.DD')}}</span>
                </li>
                <!-- v-show="prod.on" -->
                <li v-show="prod.on" style="margin-top:5px;">
                  <template v-for="(content, i) in prod.content.split('\n')">
                    <div 
                      class="alignL" 
                      :style="`${(i === 0) ? 'font-weight:700' : ''} ${(content.includes('※') || content.includes('예시)')) ? 'font-size:12px;' : ''}`"
                      :key="`pkg-prod-content-${i}`"
                    >
                      {{content}}
                    </div>
                  </template>
                  <!-- <div class="alignL" style="line-height:1.4;margin-top:10px;display:block;" v-html="prod.content"></div> -->
                </li>
              </ul>
            </div>

          </div>

          <div class="btnBox fullBtn" style="margin-top:5px;" v-if="prod.type == ASSURANCE">
            <!-- <router-link class="btnL" to="/guide/insurance">보험금 청구 방법 확인</router-link> -->
              <!-- 보험금 청구하기 -->
              <!-- <router-link v-if="used && prod.used" class="btnL" :to="`/guide/insurance/${prod.used.care_insurance_confirm_id}`">{{$store.state.insuranceName}} 청구하기</router-link> -->
              <router-link class="btnL" :to="`/guide/warranty?vtg_id=${$store.state.user.vtg_id}&subsc_id=${subscId}`">{{$store.state.insuranceName}} 청구 방법 확인</router-link> 
          </div>

        </div>

      </li>
      
    </template>

  </ul>
</div>
</template>


<script>
  import Const from '../../../helpers/Const';
  import Format from "../../../helpers/Format.js";
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        Const,
        ASSURANCE: Const.PROD.TYPE.ASSURANCE,
        CURRENCY: Const.PKG_PROD_UNIT_TYPE_CURRENCY,
        NUMBER: Const.PKG_PROD_UNIT_TYPE_NUMBER,
        activate:false,
      }
    },
    components:{},

    computed: {
      ...mapState({
        DEALER_AGENT_CDKS: (state) => {
          return state.filters.DEALER_AGENT_CDKS;
        },
      }),

      subscProds(){
        let prods = this.prods;
        prods.sort(function (a,b) {
          if (a.seq > b.seq) return 1;
          if (a.seq < b.seq) return -1;
          return 0;
        });
        return prods;
      }
    },

    filters: Format,

    props: {
      prods: {type: [Array, Object]},
      used: {type: Boolean, default: false},
      subscId: Number,
    },

    created() {},
    methods:{}
  }
</script>

<style>
.opt40 {
  opacity: 0.4;
}
.space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
